'use client'

import { useMemo } from 'react'

import { useShallow } from 'zustand/react/shallow'

import { selectGatewaysServiceMapContext } from '@modules/gateways/stores/gateways.selector'
import { useGatewaysStore } from '@modules/gateways/stores/gateways.store'
import { selectCurrentProject } from '@modules/projects/stores/projects.selector'
import { useProjectsStore } from '@modules/projects/stores/projects.store'

import { buildGatewayNode } from '../mappers'
import { projectMatchesGatewayFetch } from '../service-map.utils'

/**
 * Derives the service map tree from the current project and gateways.
 * Built synchronously so consumers (dashboard, service map) are not one effect behind the store.
 */
export function useServiceMapTree() {
  const currentProject = useProjectsStore(selectCurrentProject)
  const { gateways, lastFetchedProjectId } = useGatewaysStore(useShallow(selectGatewaysServiceMapContext))

  return useMemo(() => {
    if (!currentProject?.projectId) {
      return []
    }
    if (!projectMatchesGatewayFetch(currentProject.projectId, lastFetchedProjectId)) {
      return []
    }
    return gateways.map((gateway) => buildGatewayNode(gateway))
  }, [currentProject, lastFetchedProjectId, gateways])
}
